import React, { useState } from "react";
import AdminNewProfessionSlideOver from "../slideovers/AdminNewProfessionSlideOver";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import ProfessionsToolTable from "./tables/ProfessionsToolTable";
import AdminDeleteProfessionsSlideOver from "../slideovers/AdminDeleteProfessionsSlideOver";

const ProfessionsToolPage = () => {
  const [newProfessionSLideOver, setNewProfessionSlideOver] = useState(false);
  const [deleteSlideOver, setDeleteSlideOver] = useState(false);
  const [editInputId, setEditInputId] = useState(null);

  const handleClose = () => {
    setNewProfessionSlideOver(false);
  };

  const handleDeleteSlideOverClose = () => {
    setDeleteSlideOver(false);
  };

  const handleProfessionsTable = (type, data) => {
    switch (type) {
      case "edit":
        setEditInputId(data?.id);
        break;
      case "delete":
        setDeleteSlideOver(true);
        break;

      default:
        break;
    }
  };

  return (
    <div className="col-span-12">
      <div className="flex justify-between items-center mb-[14px] md:mb-0">
        <h4 className="text-xl md:text-2xl font-bold leading-[130%] md:leading-[180%] text-[#04091E]">
          Professions
        </h4>
        <button
          className="w-12 h-12 flex justify-center items-center rounded-[10px] bg-primary cursor-pointer"
          onClick={() => setNewProfessionSlideOver(true)}
        >
          <PlusCircleIcon className="w-6 h-6 text-white" />
        </button>
      </div>
      <ProfessionsToolTable
        handleDropDownMenu={handleProfessionsTable}
        isEditId={editInputId}
        setEditInputId={setEditInputId}
      />
      <AdminNewProfessionSlideOver
        show={newProfessionSLideOver}
        setCourseSlideOver={setNewProfessionSlideOver}
        handleClose={handleClose}
      />
      <AdminDeleteProfessionsSlideOver
        show={deleteSlideOver}
        setCourseSlideOver={setDeleteSlideOver}
        handleClose={handleDeleteSlideOverClose}
        text="profession"
      />
    </div>
  );
};

export default ProfessionsToolPage;
